module.exports = __webpack_public_path__ + "img/album_2_m.7baff702.jpg";